// §5.1 Splash — held 1.8s while checking for a saved session, then decides.
import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { getSession } from '@/api/session';
import './onboarding.css';

export const INTRO_SEEN_KEY = 'nova_intro_seen';

const Splash = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      const session = getSession();
      const introSeen = localStorage.getItem(INTRO_SEEN_KEY) === '1';

      if (!introSeen) {
        navigate('/intro', { replace: true });
      } else if (session?.type === 'FULL') {
        navigate('/applicant', { replace: true });
      } else if (session?.type === 'TRACKING') {
        navigate('/applicant', { replace: true });
      } else {
        navigate('/welcome', { replace: true });
      }
    }, 1800);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="nova-ob-dark">
      <div className="nova-ob-card-dark">
        <div className="nova-ob-center">
          <div className="nova-ob-logo-circle">N</div>
          <div className="nova-ob-brand">NovaBank</div>
          <div className="nova-ob-tagline">Banking that keeps up with you</div>
        </div>
      </div>
    </div>
  );
};

export default Splash;
